import { Injectable, TransferState, inject, makeStateKey } from '@angular/core';

import { BehaviorSubject, filter, firstValueFrom } from 'rxjs';

import { HostApiService } from '../http/host-api.service';

/**
 * @whatItDoes Provides access to manifest.json entries.
 *
 * @stable
 */
@Injectable({ providedIn: 'root' })
export class ManifestService {
    readonly apiService = inject(HostApiService);
    readonly loaded: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    readonly transferState = inject(TransferState);

    MANIFEST_TRANSFER_STATE_KEY = makeStateKey<{ [key: string]: string }>('manifest');
    loadingStarted: boolean = false;
    data: { [key: string]: string };

    async getEntry(entry: string): Promise<string | undefined> {
        await Promise.all([this.load(), firstValueFrom(this.loaded.pipe(filter((l: boolean) => l)))]);

        return this.data[entry];
    }

    async load(): Promise<void> {
        if (this.loadingStarted) return;

        this.loadingStarted = true;
        this.data = await this.getManifest();
        this.loaded.next(true);
    }

    protected async getManifest(): Promise<{ [key: string]: string }> {
        if (this.transferState.hasKey(this.MANIFEST_TRANSFER_STATE_KEY)) {
            return this.transferState.get(this.MANIFEST_TRANSFER_STATE_KEY, {});
        }
        return firstValueFrom<{ [key: string]: string }>(this.apiService.get('assets/manifest'));
    }
}
